import http from 'helpers/APIHelper';
import { map } from 'rxjs/operators';
import { openConfirmation } from 'components/Confirmation/Confirmation';

export const SITEREGISTRATION_ACTIONS = {
  SET_REGISTRATION_DETAILS: '@regulatory/siteRegistration/setRegistrationDetails',
  SET_REGISTRATION_STATUS_HISTORY: '@regulatory/siteRegistration/setRegistrationStatusHistory'
};

export const synTransaction = (token, loggerInfo, postBody) => http
  .postWithToken(`site-data-service/v1/sites/registration/rdtssync`, token, JSON.stringify(postBody), loggerInfo)
  .pipe(map((resp) => resp));

export const refreshRow = (token, loggerInfo, srId) => http
  .putWithToken(`site-data-service/v1/sites/registrations/${srId}/refresh`, token, {}, loggerInfo)
  .pipe(map((resp) => resp));

export const getSiteRegDetailsByID = (token, loggerInfo, siteRegistrationId, data) => http.postWithToken(`v1/sites/id/${siteRegistrationId}/registrationdetails`, token, data, loggerInfo);

export const getSiteRegDetails = (token, loggerInfo, protoCol, siteCtepId, callback) => (dispatch) => http
  .getWithToken(
    `site-data-service/v1/sites/number/${siteCtepId}/registrationdetails/protocol/${protoCol}`,
    token,
    loggerInfo
  )
  .subscribe((res) => {
    if (siteCtepId && protoCol && !res.response.siteRegistrationDetail) {
      openConfirmation({
        header: 'Warning',
        isClose: true,
        renderComp: () => "A Site Registration record doesn't exists for the given combination of Protocol Number and Site CTEP ID."
      });
    }
    dispatch({
      type: SITEREGISTRATION_ACTIONS.SET_REGISTRATION_DETAILS,
      payload: res.response
    });
    if (callback != null) {
      callback(res.response);
    }
  });

export const synTransactionAll = (token, loggerInfo, postBody) => http
  .postWithToken(
    `site-data-service/v1/sites/registrations/rdtssyncalltxs`,
    token,
    JSON.stringify(postBody),
    loggerInfo
  )
  .pipe(map(resp => resp));

/**
 * Site Registration: Requirement Checklist, Packet ID Grid
 * @see {@link https://jira.ctsu.org/browse/COREAPI-402 | JIRA}
 */
export const getReqChecklistPacketIds = (token, loggerInfo, srId, srclId, payload) => http.postWithToken(
  `regulatory-data-service/v1/packets/registration/${srId}/checklist/${srclId}`,
  token,
  payload,
  loggerInfo
);

export const getSiteRegStatusHistory = (token, loggerInfo, srId) => (dispatch) => http
  .getWithToken(`site-data-service/v1/sites/registration/${srId}/statushistory`, token, loggerInfo)
  .subscribe((resp) => {
    dispatch({
      type: SITEREGISTRATION_ACTIONS.SET_REGISTRATION_STATUS_HISTORY,
      payload: resp.response
    });
  });

export const saveSiteRegistrationPacketId = (token, loggerInfo, packetId, srclId, requestObj) => http.postWithToken(
  `regulatory-data-service/v1/packets/id/${packetId}/srchecklist/${srclId}`,
  token,
  requestObj,
  loggerInfo
);

export const deleteSiteRegistrationPacketId = (token, loggerInfo, packetId, srclId) => http.deleteWithToken(`regulatory-data-service/v1/packets/id/${packetId}/srchecklist/${srclId}`, token, loggerInfo);

export const saveReqdetails = (token, loggerInfo, srId, reqDetails) => http.putWithToken(
  `site-data-service/v1/sites/registration/${srId}/checklist/${reqDetails.srclId}`,
  token,
  JSON.stringify(reqDetails),
  loggerInfo
);

export const updateStatus = (token, loggerInfo, postBody, action) => http.putWithToken(`site-data-service/v1/sites/registrations/${action}`, token, JSON.stringify(postBody), loggerInfo);

export const getPreferences = (token, loggerInfo, srId) => http.getWithToken(`site-data-service/v1/sites/registration/${srId}/sitepreferences`, token, loggerInfo);

export const deleteSiteDetails = (token, loggerInfo, siteCtepId, protocolNumber) => http.deleteWithToken(
  `site-data-service/v1/sites/number/${siteCtepId}/registrationdetails/protocol/${protocolNumber}`,
  token,
  loggerInfo
);

export const refreshStatus = (token, loggerInfo, siteId, protocolNumber) => http.putWithToken(
  `site-data-service/v1/sites/registration/${siteId}/protocol/${protocolNumber}/refresh`,
  token,
  {},
  loggerInfo
);
